import { useTranslation } from 'react-i18next';
import { normalizeLang } from '../utils/localeDataLoader';

/**
 * Custom hook bao gồm toàn bộ logic ngôn ngữ:
 * - t: hàm dịch văn bản
 * - i18n: instance i18n
 * - currentLang: mã ngôn ngữ đã chuẩn hóa ('vi' | 'en' | 'jp')
 * - changeLanguage: đổi ngôn ngữ + lưu vào localStorage
 */
export const useLanguage = () => {
  const { t, i18n } = useTranslation();
  const currentLang = normalizeLang(i18n.language);

  const changeLanguage = (code) => {
    i18n.changeLanguage(code);
    localStorage.setItem('selectedLanguageCode', code);
  };

  return { t, i18n, currentLang, changeLanguage };
};
